import includes from "lodash/includes";
import styled, { css, keyframes } from "styled-components";
const SIZES = {
    WAVE_HEIGHT: 45,
    WAVE_ORIGINAL_WIDTH: 745
};
const moveLeft = keyframes `
  0% {
    background-position-x: 0;
  }
  100% {
    background-position-x: -${SIZES.WAVE_ORIGINAL_WIDTH}px;
  }
`;
export default {
    Wave: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["img", "isPlaying", "animationDuration"], prop)
    }) `
    background: url("${({ img }) => img}") repeat-x;
    height: ${SIZES.WAVE_HEIGHT}px;
    width: 100%;

    animation: ${moveLeft} 1s linear infinite;
    animation-duration: ${({ animationDuration }) => animationDuration};

    ${({ isPlaying }) => css `
      animation-play-state: ${isPlaying ? "running" : "paused"};
    `}
  `
};
